import PropTypes from "prop-types"
import "./style.scss"

function TradesError({ text }) {
  return <div className="components_trades-panel-error">
    <div className="error-description">{text}</div>
  </div>
}

TradesError.propTypes = {
  text: PropTypes.string.isRequired,
}

export default TradesError
